import { HttpService } from "../../apiAuthorization/httpService";
import { authenticationService } from '../../apiAuthorization/authenticationService';
import { history } from '../../apiAuthorization/history';
import { OfflineSyncService } from "../storageService/offlineSyncService";
import { LoadOfflineDatas } from './offlineData';

const CheckOnline = () => {
    setInterval(() => {
        const currentUser = authenticationService.currentUserValue;
        
        if (currentUser && currentUser.Token) {
            HttpService.post("/Home/IsOnline", null)
            .then(async (result) => {
                if (result && !result.offline) {
                    //sync data 
                    const offlineSyncService = new OfflineSyncService();
                    let modules = [];
                    let offlineSyncDatas = await offlineSyncService.getOfflineSyncs();
                    if (offlineSyncDatas && offlineSyncDatas.length > 0) {
                        syncData(offlineSyncService, offlineSyncDatas, modules);
                    }
                    sessionStorage.setItem("isOffline", 0);
                }
                else {
                    sessionStorage.setItem("isOffline", 1);
                }
            },
            (error) => {
                console.log(error);
            });
        }
     }, 15000);
};

const syncData = (offlineSyncService, offlineDatas, modules) => {
    if (offlineDatas.length === 0) {
        let pathName = window.location.pathname.replace(process.env.PUBLIC_URL, "");
        let defaultSite = JSON.parse(sessionStorage.getItem("defaultSite"));
        LoadOfflineDatas(defaultSite, modules, false, "0");

        if (pathName !== "/") {
            history.push('/User'); // TO DO: This is dirty work around code to refresh the screen after database sync to get the latest data. We need to find the perfect solution to reload the data. 
            history.replace(pathName);
        }

        return;
    }

    let item = offlineDatas[0];

    if (item.Name === "SaveJournal") {
        let id = item.OfflineData.AppJournalId;
        if ((id + "").substr(0, 1) === "$")
            item.OfflineData.AppJournalId = 0;
        if (!modules.includes("Journal"))
            modules.push("Journal");
    }
    else if (item.Name === "SaveAppVisitation") {
        let id = item.OfflineData.AppVisitationId;
        if ((id + "").substr(0, 1) === "$")
            item.OfflineData.AppVisitationId = 0;
        if (!modules.includes("VisitationEVS"))
            modules.push("VisitationEVS");
    }
    else if (item.Name === "SaveAppVisitationRecovery") {
        let id = item.OfflineData.AppVisitationRecoveryId;
        if ((id + "").substr(0, 1) === "$")
            item.OfflineData.AppVisitationRecoveryId = 0;
        if (!modules.includes("Recovery"))
            modules.push("Recovery");
    }
    else if ((item.Name === "SaveCoachQueue" || item.Name === "SaveSurvey") && !modules.includes("Coach")) {
         modules.push("Coach");
    }
    else if (item.Name === "SaveAppRoundWithSAT" || item.Name === "SaveAppRoundWithUNSAT" || item.Name === "SaveNotesForRoundLocation") {
        if (!modules.includes("Round"))
            modules.push("Round");
    }
    else if (item.Name === "SaveAppSafetyCoach") {
        let id = item.OfflineData.AppSafetyCoachId;
        if ((id + "").substr(0, 1) === "$")
            item.OfflineData.AppSafetyCoachId = 0;
        if (!modules.includes("SafetyCoaching"))
            modules.push("SafetyCoaching");
    } else if (item.Name === "SaveRDOSection") {
        let idLength = 12;
        if (item.OfflineData.RDOAccountVisitDto.Id.toString().length === idLength) 
            item.OfflineData.RDOAccountVisitDto.Id = 0;
        
        item.OfflineData.RDOAccountVisitDto.RDOAccountVisitSectionList.forEach(x => {
            if (x.Id.toString().length === idLength) 
                x.Id = 0;
            
            if (x.RDOAccountVisitId.toString().length === idLength )
               x.RDOAccountVisitId = 0;
        });

        if (item.OfflineData.RDOAccountVisitSectionDto.Id.toString().length === idLength) {
            item.OfflineData.RDOAccountVisitSectionDto.Id = 0;
        }
        if (item.OfflineData.RDOAccountVisitSectionDto.RDOAccountVisitId.toString().length === idLength) {
            item.OfflineData.RDOAccountVisitSectionDto.RDOAccountVisitId = 0;
        }
    }

    HttpService.post(item.Url, item.OfflineData)
    .then((result) => {
        if (item.Name === "SaveAppVisitation") {
            let templates = item.OfflineData.answers;
            let recoveries = item.OfflineData.recoveries;
            let appVisitationId = result.data.AppVisitationId;

            templates.forEach(function (template) {
                template.AppVisitation = appVisitationId;
            })

            if (recoveries !== undefined) {
                recoveries.forEach(function (recovery) {
                    recovery.AppVisitation = appVisitationId;
                    HttpService.post("/RecoveryEVS/SaveAppVisitationRecovery", recovery)
                        .then((res) => {
                        //do something
                    });
                })
            }

            HttpService.post("/VisitationEVS/SaveAppVisitationAnswer", templates)
            .then((res) => {
                offlineSyncService.removeById(item.Id);
                offlineDatas.splice(0, 1);
                syncData(offlineSyncService, offlineDatas, modules);
            });
        }
        else {
            offlineSyncService.removeById(item.Id);
            offlineDatas.splice(0, 1);
            syncData(offlineSyncService, offlineDatas, modules);
        }
    },
    (error) => {
        console.log(error);
    });
};

const CheckPageRefresh = () => {
    
    const currentUser = authenticationService.currentUserValue;
    if (currentUser && currentUser.Token) {
        let isReload = sessionStorage.getItem("Reload");
        if (isReload === "true") {
            sessionStorage.setItem("Reload", "false");
            let pathname = window.location.pathname;
            let isLogin = pathname && pathname.indexOf("/login") > -1;

            if (pathname === "/" ||
                pathname === `${process.env.PUBLIC_URL}/` ||
                pathname === `${process.env.PUBLIC_URL}` ||
                pathname === `${process.env.PUBLIC_URL}/login` || 
                pathname === `${process.env.PUBLIC_URL}login` ||
                isLogin)
                return;

            window.location.href = `${window.location.origin}${process.env.PUBLIC_URL}`;
        }
    }

    window.addEventListener("beforeunload", (event) => {
        sessionStorage.setItem("Reload", "true");
    });

}

export { CheckOnline, CheckPageRefresh }
